// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupDashboardDatabaseTableQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  serverGroupId: Types.Scalars["ID"]["input"];
}>;

export type ServerGroupDashboardDatabaseTableQuery = {
  __typename?: "GraphqlQuery";
  getServerGroupDatabases: Array<{
    __typename?: "ServerGroupDatabase";
    id: string;
    datname: string;
    server: { __typename?: "Server"; humanId: string; name: string };
  }>;
};

export const ServerGroupDashboardDatabaseTableDocument = gql`
  query ServerGroupDashboardDatabaseTable(
    $organizationSlug: ID!
    $serverGroupId: ID!
  ) {
    getServerGroupDatabases(
      organizationSlug: $organizationSlug
      serverGroupId: $serverGroupId
    ) {
      id
      datname
      server {
        humanId
        name
      }
    }
  }
`;

/**
 * __useServerGroupDashboardDatabaseTableQuery__
 *
 * To run a query within a React component, call `useServerGroupDashboardDatabaseTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupDashboardDatabaseTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupDashboardDatabaseTableQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      serverGroupId: // value for 'serverGroupId'
 *   },
 * });
 */
export function useServerGroupDashboardDatabaseTableQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupDashboardDatabaseTableQuery,
    ServerGroupDashboardDatabaseTableQueryVariables
  > &
    (
      | {
          variables: ServerGroupDashboardDatabaseTableQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupDashboardDatabaseTableQuery,
    ServerGroupDashboardDatabaseTableQueryVariables
  >(ServerGroupDashboardDatabaseTableDocument, options);
}
export function useServerGroupDashboardDatabaseTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupDashboardDatabaseTableQuery,
    ServerGroupDashboardDatabaseTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupDashboardDatabaseTableQuery,
    ServerGroupDashboardDatabaseTableQueryVariables
  >(ServerGroupDashboardDatabaseTableDocument, options);
}
// @ts-ignore
export function useServerGroupDashboardDatabaseTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupDashboardDatabaseTableQuery,
    ServerGroupDashboardDatabaseTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupDashboardDatabaseTableQuery,
  ServerGroupDashboardDatabaseTableQueryVariables
>;
export function useServerGroupDashboardDatabaseTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupDashboardDatabaseTableQuery,
        ServerGroupDashboardDatabaseTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupDashboardDatabaseTableQuery | undefined,
  ServerGroupDashboardDatabaseTableQueryVariables
>;
export function useServerGroupDashboardDatabaseTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupDashboardDatabaseTableQuery,
        ServerGroupDashboardDatabaseTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupDashboardDatabaseTableQuery,
    ServerGroupDashboardDatabaseTableQueryVariables
  >(ServerGroupDashboardDatabaseTableDocument, options);
}
export type ServerGroupDashboardDatabaseTableQueryHookResult = ReturnType<
  typeof useServerGroupDashboardDatabaseTableQuery
>;
export type ServerGroupDashboardDatabaseTableLazyQueryHookResult = ReturnType<
  typeof useServerGroupDashboardDatabaseTableLazyQuery
>;
export type ServerGroupDashboardDatabaseTableSuspenseQueryHookResult =
  ReturnType<typeof useServerGroupDashboardDatabaseTableSuspenseQuery>;
export type ServerGroupDashboardDatabaseTableQueryResult = Apollo.QueryResult<
  ServerGroupDashboardDatabaseTableQuery,
  ServerGroupDashboardDatabaseTableQueryVariables
>;
